import { render } from "./TextareaInput.vue?vue&type=template&id=0503efb8&scoped=true"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"

import "./TextareaInput.vue?vue&type=style&index=0&id=0503efb8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0503efb8"]])

export default __exports__